import { ApiConfig } from "../../../api/apiConfig/apiConfig";

export const DEFAULT_AVATAR = "/images/user_icon.svg";

export const formatAmount = (value, digits = 2) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "0";
  return num.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });
};

export const formatPnl = (value, digits = 2) => {
  const num = Number(value) || 0;
  const sign = num > 0 ? "+" : "";
  return `${sign}${formatAmount(num, digits)}`;
};

export const pnlClass = (value) => {
  const num = Number(value) || 0;
  if (num > 0) return "ct-pnl-positive";
  if (num < 0) return "ct-pnl-negative";
  return "";
};

export const usdt = (value, digits = 2) => `${formatAmount(value, digits)} USDT`;

export const pnlUsdt = (value, digits = 2) => `${formatPnl(value, digits)} USDT`;

export const displayPair = (item) => {
  const pair = String(item?.pair || "").trim();
  if (/^[A-Za-z0-9]+\/[A-Za-z0-9]+$/.test(pair)) return pair;
  const base = String(item?.base_currency || "").trim();
  const quote = String(item?.quote_currency || item?.short_name || "USDT").trim();
  if (base && quote) return `${base}/${quote}`;
  const fromTrades = Array.isArray(item?.recentTrades)
    ? item.recentTrades
        .map((trade) => String(trade?.pair || "").trim())
        .find((value) => /^[A-Za-z0-9]+\/[A-Za-z0-9]+$/.test(value))
    : "";
  if (fromTrades) return fromTrades;
  return quote || "USDT";
};

export const followerCount = (master) => {
  if (Number(master?.displayFollowers) > 0) return master.displayFollowers;
  return master?.realFollowerCount || 0;
};

export const masterImage = (path) => {
  const image = String(path || "").trim();
  if (!image) return DEFAULT_AVATAR;
  return `${ApiConfig.baseImage}${image.replace(/^\//, "")}`;
};

export const tradeStatusLabel = (status) => {
  if (status === "OPEN") return "In Progress";
  if (status === "EXECUTED") return "Executed";
  if (status === "CANCELLED") return "Cancelled";
  return status || "—";
};

export const statusClass = (status) => {
  if (status === "OPEN") return "open";
  if (status === "EXECUTED") return "executed";
  if (status === "CANCELLED") return "cancelled";
  return "";
};
